import type { SignupRegion } from '@server/signup-answers';

/** The region field label of both sign-up paths: the form behind the emailed link, and Google. */
export const REGION_FIELD_LABEL = 'RudderStack workspace region';

/** Under the label: what the region means, for a reader who cannot open the tooltip. */
export const REGION_HINT = "Your RudderStack data is stored in this region. You can't change the region later.";

/** The region is RudderStack's data residency. Lookout's own data does not move with it. */
export const REGION_SCOPE_NOTE =
  'Signing up will create a RudderStack workspace for Lookout. The selected region applies only to your RudderStack workspace and its resources, not to Lookout.';

export const REGION_LABELS: Record<SignupRegion, string> = { US: 'United States', EU: 'Europe' };
